import { DashboardData, CalculatedData } from './types';

export const calculateDashboardData = (data: DashboardData): CalculatedData => {
  const totalHiring = data.generalHiring + data.techHiring;
  const costPerHire = (data.budget * 10000) / totalHiring / 10000;

  // Brand Visibility計算
  let brandVisibilityBase = 3.2;
  brandVisibilityBase += (data.salary - 22.6) * 0.02;
  brandVisibilityBase += (data.stability - 3.0) * 0.15;
  brandVisibilityBase += (data.organicRatio - 30) * 0.01;
  brandVisibilityBase += (data.pagePV - 5000) * 0.0002;
  const brandVisibility = Math.max(1.0, Math.min(5.0, brandVisibilityBase));

  // 実効就活母集団率計算
  const effectiveJobSeekingRate = Math.max(
    20,
    Math.min(
      80,
      30 +
        (data.salary - 20) * 0.5 +
        (data.stability - 3.0) * 2 +
        (data.growth - 3.0) * 1.5 +
        (data.rating - 3.0) * 3
    )
  );

  // 最終採用倍率計算
  const baseRatio = 8.5;
  const budgetFactor = Math.max(0.5, 50 / costPerHire);
  const prFactor = Math.max(0.7, 1.0 - data.prMeasures * 0.05);
  const stabilityFactor = Math.max(0.7, 1.0 - (data.stability - 3.0) * 0.1);
  const growthFactor = Math.max(0.7, 1.0 - (data.growth - 3.0) * 0.1);

  // 最終採用倍率計算（最低値を2.0に制限：採用ファネル分析が右向きに単調減少になるようにするため）
  const finalRatio = Math.max(
    2.0,
    baseRatio *
      (totalHiring / 50) *
      (3.5 / brandVisibility) *
      data.industry *
      data.companySize *
      data.regionalFactor *
      budgetFactor *
      prFactor *
      stabilityFactor *
      growthFactor
  );

  // 採用難易度判定
  let difficulty, difficultyClass;
  // 注意: finalRatioは上記で2.0以上に制限されているため、finalRatio < 2.0の条件は到達不可能
  // ただし、今後finalRatioの最低値制限を変更する可能性があるため、この分岐は残しておく
  if (finalRatio < 2.0) {
    difficulty = 'EASY';
    difficultyClass = 'difficulty-easy';
  } else if (finalRatio < 5.0) {
    difficulty = 'NORMAL';
    difficultyClass = 'difficulty-normal';
  } else if (finalRatio < 10.0) {
    difficulty = 'HARD';
    difficultyClass = 'difficulty-hard';
  } else if (finalRatio < 15.0) {
    difficulty = 'VERY HARD';
    difficultyClass = 'difficulty-very-hard';
  } else {
    difficulty = 'EXTREME';
    difficultyClass = 'difficulty-extreme';
  }

  const requiredApplicants = Math.ceil(totalHiring * finalRatio);

  return {
    finalRatio,
    difficulty,
    difficultyClass,
    requiredApplicants,
    costPerHire,
    brandVisibility,
    effectiveJobSeekingRate,
  };
};
